let Stacks = {
    STACK_WITH_POSITION: 'position',
    STACK_WITH_PLAYER: 'player',

    STACK_WITH_TEAM_EXCLUSION: 'teamExclusion',
    STACK_WITH_PLAYER_EXCLUSION: 'playerExclusion',

    STACKS_TYPE_AT_MOST: '<=',
    STACKS_TYPE_AT_LEAST: '>=',
    STACKS_TYPE_EXACTLY: '=',

    STACKS_NUMBER_TYPE_AT_MOST: 1,
    STACKS_NUMBER_TYPE_AT_LEAST: 2,
    STACKS_NUMBER_TYPE_EXACTLY: 3,

    USE_POSITION_STACK: 'USE_POSITION_STACK',
    SET_POSITION_STACK: 'SET_POSITION_STACK',
    REMOVE_POSITION_STACK: 'REMOVE_POSITION_STACK',
    RESET_POSITION_STACKS: 'RESET_POSITION_STACKS',
    UNRESET_POSITION_STACKS: 'UNRESET_POSITION_STACKS',

    SET_DOMINATOR_STACK: 'SET_DOMINATOR_STACK',
    REMOVE_DOMINATOR_STACK: 'REMOVE_DOMINATOR_STACK',
    RESET_DOMINATOR_STACKS: 'RESET_DOMINATOR_STACKS',
    UNRESET_DOMINATOR_STACKS: 'UNRESET_DOMINATOR_STACKS',

    MIN_PLAYERS_IN_TEAM_STACK: 1,
    USE_TEAM_STACK: 'USE_TEAM_STACK',
    SET_TEAM_STACK: 'SET_TEAM_STACK',
    REMOVE_TEAM_STACK: 'REMOVE_TEAM_STACK',
    RESET_TEAM_STACKS: 'RESET_TEAM_STACKS',
    UNRESET_TEAM_STACKS: 'UNRESET_TEAM_STACKS',

    NHL_NAME_STACK_IS_USED: 'NHL_NAME_STACK_IS_USED',
    NHL_NAME_STACK_IS_DOUBLE_STACK_MODE: 'NHL_NAME_STACK_IS_DOUBLE_STACK_MODE',
    NHL_NAME_STACK_SET_PLAYERS_IN_GROUP: 'NHL_NAME_STACK_SET_PLAYERS_IN_GROUP',
    NHL_NAME_STACK_ADD_ITEM: 'NHL_NAME_STACK_ADD_ITEM',
    NHL_NAME_STACK_REMOVE_ITEM: 'NHL_NAME_STACK_REMOVE_ITEM',
    NHL_NAME_STACK_SET_TEAM_TO_ITEM: 'NHL_NAME_STACK_SET_TEAM_TO_ITEM',
    NHL_NAME_STACK_SET_EXPOSURE_TO_ITEM: 'NHL_NAME_STACK_SET_EXPOSURE_TO_ITEM',
    NHL_NAME_STACK_SET_PLAYER_TO_ITEM: 'NHL_NAME_STACK_SET_PLAYER_TO_ITEM',
    NHL_NAME_STACK_MIN_PLAYERS_QUANTITY: 2,

    NHL_NAME_STACK_FIRST_GROUP: 1,
    NHL_NAME_STACK_SECOND_GROUP: 2,

    NHL_NON_CONTROLLED_STACK_IS_USED: 'NHL_NON_CONTROLLED_STACK_IS_USED',
    NHL_NON_CONTROLLED_STACK_SET_LINE_GROUP_TO_ITEM: 'NHL_NON_CONTROLLED_STACK_SET_LINE_GROUP_TO_ITEM',
    NHL_NON_CONTROLLED_STACK_SET_PP_LINE_TO_ITEM: 'NHL_NON_CONTROLLED_STACK_SET_PP_LINE_TO_ITEM',
    NHL_NON_CONTROLLED_STACK_RESET_STACK: 'NHL_NON_CONTROLLED_STACK_RESET_STACK',
    NHL_NON_CONTROLLED_STACK_SET_EXPOSURE_TO_ITEM: 'NHL_NON_CONTROLLED_STACK_SET_EXPOSURE_TO_ITEM',
    NHL_NON_CONTROLLED_STACK_SET_TEAM_TO_ITEM: 'NHL_NON_CONTROLLED_STACK_SET_TEAM_TO_ITEM',
    NHL_NON_CONTROLLED_STACK_ADD_ITEM: 'NHL_NON_CONTROLLED_STACK_ADD_ITEM',
    NHL_NON_CONTROLLED_STACK_REMOVE_ITEM: 'NHL_NON_CONTROLLED_STACK_REMOVE_ITEM',
    NHL_NON_CONTROLLED_STACK_SET_PLAYERS_IN_GROUP: 'NHL_NON_CONTROLLED_STACK_SET_PLAYERS_IN_GROUP',
    NHL_NON_CONTROLLED_STACK_SET_STACK_MODE: 'NHL_NON_CONTROLLED_STACK_SET_STACK_MODE',
    NHL_NON_CONTROLLED_STACK_MIN_PLAYERS_QUANTITY: 2,
    NHL_NON_CONTROLLED_STACK_LINE_GROUPS: [1, 2, 3, 4],
    NHL_NON_CONTROLLED_STACK_PP_LINES: [1, 2],
    NHL_NON_CONTROLLED_STACK_MAX_GROUPS: 3,

    SET_NON_CONTROLLED_STACK: 'SET_NON_CONTROLLED_STACK',
    REMOVE_NON_CONTROLLED_STACK: 'REMOVE_NON_CONTROLLED_STACK',

    USE_HITTERS_STACK: 'USE_HITTERS_STACK',
    HITTERS_STACK_IS_DOUBLE_STACK_MODE: 'IS_DOUBLE_STACK_MODE',
    SET_HITTER_STACK_PLAYERS_IN_GROUP: 'SET_HITTER_STACK_PLAYERS_IN_GROUP',
    HITTERS_STACK_MIN_PLAYERS_QUANTITY: 2,
    HITTERS_STACK_ADD_ITEM: 'HITTERS_STACK_ADD_ITEM',
    HITTERS_STACK_REMOVE_ITEM: 'HITTERS_STACK_REMOVE_ITEM',
    HITTERS_STACK_SET_TEAM_TO_ITEM: 'HITTERS_STACK_SET_TEAM_TO_ITEM',
    HITTERS_STACK_SET_EXPOSURE_TO_ITEM: 'HITTERS_STACK_SET_EXPOSURE_TO_ITEM',
    HITTERS_STACK_SET_PLAYER_TO_ITEM: 'HITTERS_STACK_SET_PLAYER_TO_ITEM',
    HITTERS_STACK_SET_DATA_FROM_STORAGE: 'HITTERS_STACK_SET_DATA_FROM_STORAGE',

    POSITION_STACK_AVOID_POSITIONS: [],

    FIRST_HITTER_GROUP: 1,
    SECOND_HITTER_GROUP: 2,

    LEGACY_CONTROLLED_STACKING_EXP_MIN_PERCENT: 1,
    LEGACY_CONTROLLED_STACKING_EXP_MAX_PERCENT: 100,

    PLAYER_GROUPINGS_SWITCH_IS_ON: 'PLAYER_GROUPINGS_SWITCH_IS_ON',
};

export default Stacks;
